import { render } from "./NotesDrafts.vue?vue&type=template&id=131c320c"
import script from "./NotesDrafts.vue?vue&type=script&lang=js"
export * from "./NotesDrafts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__